const quantileSggData = {
	title: ['pinogio:vi_sgg', 'vi_sgg'],
	legend: ['활력도 높음 - 1', '2', '3', '4', '활력도 낮음 - 5'],
	// color: ['#012a4a', '#01497c', '#2a6f97', '#468faf', '#89c2d9'],
	// color: ['#54478C', '#048BA8', '#83E377', '#EFEA5A', '#F29E4C'],
	color: ['#a50026', '#f46d43', '#e0f3f8', '#74add1', '#313695'],
	region: {
		field: 'lv1_all',
		data: [
			{
				min: 29.348,
				max: 82.21,
			},
			{
				min: 19.22,
				max: 29.348,
			},
			{
				min: 9.61,
				max: 19.22,
			},
			{
				min: 5.296,
				max: 9.61,
			},
			{
				min: 2.26,
				max: 5.296,
			},
		],
	},
	pop: {
		field: 'l1_1',
		data: [
			{
				min: 31.04,
				max: 99.04,
			},
			{
				min: 17.908,
				max: 31.04,
			},
			{
				min: 7.458,
				max: 17.908,
			},
			{
				min: 2.79,
				max: 7.458,
			},
			{
				min: 0,
				max: 2.79,
			},
		],
	},
	consume: {
		field: 'l1_2',
		data: [
			{
				min: 28.468,
				max: 90.88,
			},
			{
				min: 16.196,
				max: 28.468,
			},
			{
				min: 6.282,
				max: 16.196,
			},
			{
				min: 2.362,
				max: 6.282,
			},
			{
				min: 0.1,
				max: 2.362,
			},
		],
	},
	prod: {
		field: 'l1_3',
		data: [
			{
				min: 28.996,
				max: 76.93,
			},
			{
				min: 21.64,
				max: 28.996,
			},
			{
				min: 14.428,
				max: 21.64,
			},
			{
				min: 10.304,
				max: 14.428,
			},
			{
				min: 4.43,
				max: 10.304,
			},
		],
	},
};

const quantileEmdData = {
	// title: ['pinogio:vi_emd', 'vi_emd'],
	// legend: ['10% 이상', '10% - 20%', '20% - 30%', '30% - 40%', '40% - 50%', '50% - 60%', '60% - 70%', '70% - 80%', '80% - 90%', '90% 이상'],
	// legend: ['활력도 높음', '', '', '', '활력도 낮음'],
	// color: ['#EA3323','#F6CA45', '#C6FD9B', '#62BFF9', '#0202F5'],
	legend: ['활력도 높음 - 1', '2', '3', '4', '5', '6', '7', '8', '9', '활력도 낮음 - 10'],
	color: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
	// color: ['#FF0000', '#FF6F00', '#FFB700', '#FFFF00', '#D2FF69', '#91FFB4', '#00FFFF', '#38ACFF', '#3561FF', '#0A0AFF'], // 원본

	// color: ['#54478C', '#2C699A', '#048BA8', '#0DB39E', '#16DB93', '#83E377', '#B9E769', '#EFEA5A', '#F1C453', '#F29E4C'], // 후보1

	// color: ['#E574BC', '#EA84C9', '#EF94D5', '#F9B4ED', '#EABAF6', '#DABFFF', '#C4C7FF', '#ADCFFF', '#96D7FF', '#7FDEFF'], // 후보2

	// color: ['#FBF8CC', '#FDE4CF', '#FFCFD2', '#F1C0E8', '#CFBAF0', '#A3C4F3', '#90DBF4', '#8EECF5', '#98F5E1', '#98F5E1'], // 후보3

	// color: ['#2D00F7', '#6A00F4', '#8900F2', '#A100F2', '#B100E8', '#BC00DD', '#D100D1', '#DB00B6', '#E500A4', '#F20089'], // 후보4

	// color: ['#EA698B', '#D55D92', '#C05299', '#AC46A1', '#973AA8', '#822FAF', '#6D23B6', '#6411AD', '#571089', '#47126B'], // 후보5

	// color: ['#54478c', '#2C699A', '#048BA8', '#0DB39E', '#16DB93', '#83E377', '#B9E769', '#EFEA5A', '#F1C453', '#F29E4C'], // 후보6

	// color: ['#CC4400', '#D66915', '#E08E29', '#F0C761', '#FFFF99', '#C2FCFF', '#7CC6DE', '#3890BC', '#1C489A', '#000077'], // 후보8

	region: {
		field: 'vi',
		data: [
			{
				min: 19.6151,
				max: 74.881,
			},
			{
				min: 13.8859,
				max: 19.6151,
			},
			{
				min: 10.8958,
				max: 13.8859,
			},
			{
				min: 8.1318,
				max: 10.8958,
			},
			{
				min: 5.8446,
				max: 8.1318,
			},
			{
				min: 3.9521,
				max: 5.8446,
			},
			{
				min: 2.1502,
				max: 3.9521,
			},
			{
				min: 1.1702,
				max: 2.1502,
			},
			{
				min: 0.6382,
				max: 1.1702,
			},
			{
				min: 0.0021,
				max: 0.6382,
			},
		],
	},
	pop: {
		field: 'm12',
		data: [
			{
				min: 24.1325,
				max: 92.7926,
			},
			{
				min: 16.8795,
				max: 24.1325,
			},
			{
				min: 12.8874,
				max: 16.8795,
			},
			{
				min: 9.4961,
				max: 12.8874,
			},
			{
				min: 6.5559,
				max: 9.4961,
			},
			{
				min: 4.0709,
				max: 6.5559,
			},
			{
				min: 2.0953,
				max: 4.0709,
			},
			{
				min: 1.2238,
				max: 2.0953,
			},
			{
				min: 0.749,
				max: 1.2238,
			},
			{
				min: 0,
				max: 0.749,
			},
		],
	},
	consume: {
		field: 'm34',
		data: [
			{
				min: 24.2436,
				max: 100,
			},
			{
				min: 17.349,
				max: 24.2436,
			},
			{
				min: 13.1053,
				max: 17.349,
			},
			{
				min: 9.5564,
				max: 13.1053,
			},
			{
				min: 6.55,
				max: 9.5564,
			},
			{
				min: 4.0333,
				max: 6.55,
			},
			{
				min: 2.2225,
				max: 4.0333,
			},
			{
				min: 1.3182,
				max: 2.2225,
			},
			{
				min: 0.8052,
				max: 1.3182,
			},
			{
				min: 0,
				max: 0.8052,
			},
		],
	},
	prod: {
		field: 'm56',
		data: [
			{
				min: 11.5523,
				max: 96.3239,
			},
			{
				min: 7.961,
				max: 11.5523,
			},
			{
				min: 5.8749,
				max: 7.961,
			},
			{
				min: 4.5064,
				max: 5.8749,
			},
			{
				min: 3.403,
				max: 4.5064,
			},
			{
				min: 2.345,
				max: 3.403,
			},
			{
				min: 1.437,
				max: 2.345,
			},
			{
				min: 0.7463,
				max: 1.437,
			},
			{
				min: 0.2571,
				max: 0.7463,
			},
			{
				min: 0,
				max: 0.2571,
			},
		],
	},
};

export { quantileSggData, quantileEmdData };
